import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpClient } from "@/shared/api/http-client";
import type { StripeProduct, UpdateProductInput } from "./types";
import { CATALOG_PRODUCTS_QUERY_KEY } from "./use-products-list";

interface UpdateParams {
  readonly id: string;
  readonly input: UpdateProductInput;
}

async function updateProduct({ id, input }: UpdateParams): Promise<StripeProduct> {
  return httpClient<StripeProduct>(`/api/admin/catalog/products/${encodeURIComponent(id)}`, {
    method: "PATCH",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(input),
  });
}

export function useUpdateProduct() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateProduct,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: CATALOG_PRODUCTS_QUERY_KEY });
    },
  });
}
